"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noValidation = _interopRequireDefault(require("./noValidation"));

var _Action = _interopRequireDefault(require("./Action"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Actions = function Actions() {
  var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var nsValidation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noValidation["default"];
  var ActionCreator = (0, _Action["default"])(namespace, nsValidation);
  var actions = ActionCreator(name);
  actions.succeeded = ActionCreator("".concat(name, "_SUCCEEDED"));
  actions.failed = ActionCreator("".concat(name, "_FAILED"));
  return Object.freeze(actions);
};

var _default = Actions;
exports["default"] = _default;